export enum FileEntity {
  ENTITY,
  DRAW,
}

export const getBasePath = (fileEntity: FileEntity): string | undefined => {
  switch (fileEntity) {
    case FileEntity.ENTITY:
      return "entities/files";
    case FileEntity.DRAW:
      return "draw-files";
    default:
      return undefined;
  }
};
